import React, { useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import IconFont from "../elements/IconFont"
import { EmailIcon } from "../Icons"
import { OtpArray } from "../../types"
import { TriggerToast } from "../globals/Toaster"
import OneTimePassword from "../globals/Otp"
import PageNavigator from "../elements/PageNavigator"
import { useAuthService } from "../hooks/services/useAuthService"
import PasswordInput from "../elements/PasswordInput"

const ForgotPasswordVerification: React.FC = (): React.ReactElement => {

  const navigate = useNavigate()
  const authService = useAuthService()

  const { email = '' } = useParams<{ email: string }>()

  const [newPassword, setNewPassword] = useState<string>("")

  const [oneTimePassword, setOneTimePassword] = useState<OtpArray>(['', '', '', ''])

  const [criteria, setCriteria] = useState({
    length: false,
    uppercase: false,
    number: false,
    specialCharacter: false
  })

  const handleNewPasswordChange = (value: string) => {
    setNewPassword(value)
    validatePassword(value)
  }

  const validatePassword = (password: string) => {
    const length = password.length >= 8
    const uppercase = /[A-Z]/.test(password)
    const number = /[0-9]/.test(password)
    const specialCharacter = /[!@#$%^&*(),.?":{}|<>]/.test(password)

    setCriteria({
      length,
      uppercase,
      number,
      specialCharacter
    })
  }

  const handleSubmitResetPassword = (e: React.FormEvent) => {
    e.preventDefault()
    authService.resetPassword(oneTimePassword.join(''), email, newPassword).then((response) => {
      TriggerToast(response.message, undefined, 'success')
      setTimeout(() => {
        navigate('/login')
      }, 1000)
    }).catch((error) => {
      TriggerToast(error.message, undefined, 'error')
    })
  }

  return (
    <div className="h-full mx-auto mt-[16px] block">
      <div>
        <PageNavigator headingTitle="Reset Password" />
      </div>
      <form method="POST" className="flex items-center justify-center flex-col pt-[24px]" onSubmit={handleSubmitResetPassword}>
        <div className="ui-panel-icon p-2">
          <EmailIcon />
        </div>
        <h2 className="text-[24px] font-semibold mt-[32px] text-center">Verify OTP</h2>
        <p className="mt-[8px] text-md text-center mb-[32px]">An OTP has been sent to your email address. <strong>Please check your inbox and enter the OTP below.</strong></p>

        <OneTimePassword oneTimePassword={oneTimePassword} setOneTimePassword={setOneTimePassword} />
        <div className="field my-2">
          <label htmlFor="password" className="field-label text-center">New Password</label>
          <PasswordInput value={newPassword} onChange={(e) => handleNewPasswordChange(e.target.value)} name="password" id="password" inputClasses="text-center" />
        </div>
        {newPassword.length > 0 && (
          <div className="bg-background-surface-01 flex flex-col gap-[8px] my-[8px] p-[8px] rounded-[6px] w-full ">

            <span className="ui-password-requirement flex gap-[8px] items-center leading-[1] text-xs">
              <span>
                {criteria.length ? <IconFont name="check" size={16} /> : <IconFont name="x" size={16} />}
              </span>
              <span className={criteria.length ? 'text-state-success' : ''}>Password must be at least 8 characters long.</span>
            </span>

            <span className="ui-password-requirement flex gap-[8px] items-center leading-[1] text-xs">
              <span>
                {criteria.uppercase ? <IconFont name="check" size={16} /> : <IconFont name="x" size={16} />}
              </span>
              <span className={criteria.uppercase ? 'text-state-success' : ''}>Include at least one uppercase letter (A-Z).</span>
            </span>
            <span className="ui-password-requirement flex gap-[8px] items-center leading-[1] text-xs">
              <span>
                {criteria.number ? <IconFont name="check" size={16} /> : <IconFont name="x" size={16} />}
              </span>
              <span className={criteria.number ? 'text-state-success' : ''}>Include at least one numerical digit (0-9).</span>
            </span>
            <span className="ui-password-requirement flex gap-[8px] items-center leading-[1] text-xs">
              <span>
                {criteria.specialCharacter ? <IconFont name="check" size={16} /> : <IconFont name="x" size={16} />}
              </span>
              <span className={criteria.specialCharacter ? 'text-state-success' : ''}>Include at least one special character (e.g., !, @, #, $).</span>
            </span>
          </div>
        )}
        <button type="submit" name="submit" className="btn-primary">Submit</button>
      </form>
    </div>
  )
}

export default ForgotPasswordVerification
